module.exports = "//static.hsappstatic.net/payments-enrollment-embed-lib/static-1.14569/images/StripeLogo.svg"